<form [formGroup]="form">
  <app-datepicker
    [control]="getFormCtrl()">
  </app-datepicker>
  <app-form-error [form]="form" [controlName]="'control'" *ngIf="isRequiredField()"></app-form-error>
</form>
